'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';
import { ELanguage } from '../Utils/constants.js';
import { SUCCESS_CODE, LIMIT_PER_PAGE } from './constant.js';

var searchJobs = function (_a) {
    var baseUrl = _a.baseUrl, params = _a.params, _b = _a.xSource, xSource = _b === void 0 ? 'Page-Container' : _b, _c = _a.langCode, langCode = _c === void 0 ? ELanguage.VI : _c;
    return __awaiter(void 0, void 0, void 0, function () {
        var urlApi, retrieveFields, finalParams, response, data, error_1;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    urlApi = "".concat(baseUrl, "/job-search/v1.0/search");
                    retrieveFields = [
                        'address',
                        'benefits',
                        'jobTitle',
                        'isSalaryVisible',
                        'isShowLogo',
                        'companyLogo',
                        'userId',
                        'jobLevel',
                        'jobLevelId',
                        'jobLevelVI',
                        'jobId',
                        'companyId',
                        'approvedOn',
                        'isAnonymous',
                        'alias',
                        'expiredOn',
                        'industries',
                        'workingLocations',
                        'services',
                        'companyName',
                        'onlineOn',
                        'simpleServices',
                        'visibilityDisplay',
                        'isShowLogoInSearch',
                        'priorityOrder',
                        'skills',
                        'profilePublishedSiteMask',
                        'salaryMin',
                        'salaryMax',
                        'prettySalary',
                        'jobDescription',
                        'jobRequirement'
                    ];
                    finalParams = __assign({ userId: 0, query: '', filter: [], ranges: [], order: [], hitsPerPage: LIMIT_PER_PAGE, page: 0, retrieveFields: retrieveFields }, params);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(urlApi, {
                            method: 'POST',
                            mode: 'cors',
                            headers: {
                                'Accept-Language': langCode,
                                'X-Source': xSource,
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(finalParams)
                        })];
                case 2:
                    response = _e.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _e.sent();
                    if (((_d = data === null || data === void 0 ? void 0 : data.meta) === null || _d === void 0 ? void 0 : _d.code) === SUCCESS_CODE) {
                        return [2 /*return*/, {
                                data: data.data,
                                meta: data.meta,
                                error: ''
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: [],
                                meta: [],
                                error: data === null || data === void 0 ? void 0 : data.message
                            }];
                    }
                case 4:
                    error_1 = _e.sent();
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
};

export { searchJobs };
//# sourceMappingURL=services.js.map
